export default "__VITE_ASSET__De0iEAKM__"